var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { create } from 'braintree-web/client';
import { create as hostedFieldsCreate } from 'braintree-web/hosted-fields';
import { create as paypalCreate } from 'braintree-web/paypal-checkout';
import { VendorPaymentAdapter } from './VendorPaymentAdapter';
import { SupportedPaymentMethodMappings, SupportedPaymentMethods } from '../services/ApplicationSession';
import { threeDSecure } from 'braintree-web';
import { ErrorType, PaymentError } from '../services/ErrorService';
import { convertToDollars } from '../common/CurrencyConverter';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getTraditionalLocale } from '../common/Constants';
dayjs.extend(customParseFormat);
var BraintreeAdapter = /** @class */ (function (_super) {
    __extends(BraintreeAdapter, _super);
    function BraintreeAdapter(config, billingGatewayService, callbacks) {
        var _this = _super.call(this) || this;
        _this.renderedComponents = {
            creditCard: false,
            paypal: false
        };
        _this.supportedCardBrandsToHostedFieldsSupportedCardBrands = function (supportedCardBrands) {
            var hostedFieldsSupportedCards = {};
            supportedCardBrands.forEach(function (supportedCardBrand) {
                hostedFieldsSupportedCards[supportedCardBrand] = true;
            });
            return hostedFieldsSupportedCards;
        };
        _this.onProcessing = callbacks.onProcessing;
        if (!config.braintreeClientToken) {
            throw new Error('No braintreeClientToken passed to BraintreeAdapter!');
        }
        _this.braintreeClient = create({
            authorization: config.braintreeClientToken
        });
        _this.billingGatewayService = billingGatewayService;
        return _this;
    }
    BraintreeAdapter.prototype.remountCreditCardForm = function () {
        return;
    };
    BraintreeAdapter.prototype.initializeCreditCard = function (formRef, callbacks, cardFieldStyling, supportedCardBrands, onInitialized) {
        return __awaiter(this, void 0, void 0, function () {
            var client, hostedFieldsFields;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.renderedComponents.creditCard) {
                            return [2 /*return*/];
                        }
                        onInitialized(); // TODO need to find Braintree callback for this
                        this.renderedComponents.creditCard = true;
                        return [4 /*yield*/, this.braintreeClient];
                    case 1:
                        client = _a.sent();
                        hostedFieldsFields = {
                            number: {
                                container: '#card-number',
                                supportedCardBrands: this.supportedCardBrandsToHostedFieldsSupportedCardBrands(supportedCardBrands)
                            },
                            cvv: {
                                container: '#cvv'
                            },
                            expirationDate: {
                                container: '#expiration-date'
                            }
                        };
                        hostedFieldsCreate({
                            client: client,
                            fields: hostedFieldsFields,
                            styles: cardFieldStyling
                        }, function (hostedFieldsErr, hostedFieldsInstance) {
                            if (hostedFieldsErr) {
                                console.error(hostedFieldsErr);
                                return;
                            }
                            var BrainTreeHostedFieldsInstance = hostedFieldsInstance;
                            BrainTreeHostedFieldsInstance.getSupportedCardTypes().then(function (brandList) {
                                if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.onSupportedCardBrands) {
                                    callbacks.onSupportedCardBrands(brandList);
                                }
                            });
                            BrainTreeHostedFieldsInstance === null || BrainTreeHostedFieldsInstance === void 0 ? void 0 : BrainTreeHostedFieldsInstance.on('cardTypeChange', function (event) {
                                var _a, _b;
                                var selectedBrand = undefined;
                                if (event.cards.length === 1) {
                                    var selectedCard = event.cards[0];
                                    if (!selectedCard.supported) {
                                        var isValid = event.fields.cvv.isValid && event.fields.number.isValid && event.fields.expirationDate.isValid;
                                        (_a = callbacks.onValidityChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, {
                                            validCVV: event.fields.cvv.isValid,
                                            validCreditCardNumber: event.fields.number.isValid,
                                            validCardBrand: false,
                                            validExpiryYear: event.fields.expirationDate.isValid,
                                            validExpiryMonth: event.fields.expirationDate.isValid,
                                            isValid: isValid
                                        });
                                        return;
                                    }
                                    selectedBrand = selectedCard.type;
                                }
                                (_b = callbacks.onBrand) === null || _b === void 0 ? void 0 : _b.call(callbacks, selectedBrand);
                            });
                            BrainTreeHostedFieldsInstance === null || BrainTreeHostedFieldsInstance === void 0 ? void 0 : BrainTreeHostedFieldsInstance.on('validityChange', function (event) {
                                var _a;
                                var isValid = event.fields.cvv.isValid && event.fields.number.isValid && event.fields.expirationDate.isValid;
                                (_a = callbacks.onValidityChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, {
                                    validCVV: event.fields.cvv.isValid,
                                    validCreditCardNumber: event.fields.number.isValid,
                                    validCardBrand: true,
                                    validExpiryYear: event.fields.expirationDate.isValid,
                                    validExpiryMonth: event.fields.expirationDate.isValid,
                                    isValid: isValid
                                });
                            });
                            BrainTreeHostedFieldsInstance === null || BrainTreeHostedFieldsInstance === void 0 ? void 0 : BrainTreeHostedFieldsInstance.on('focus', function (event) {
                                var _a;
                                var fields = event.fields;
                                (_a = callbacks.onCardFieldsStatusChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, {
                                    number: {
                                        focused: fields.number.isFocused,
                                        empty: fields.number.isEmpty
                                    },
                                    expirationDate: {
                                        focused: fields.expirationDate.isFocused,
                                        empty: fields.expirationDate.isEmpty
                                    },
                                    cvv: {
                                        focused: fields.cvv.isFocused,
                                        empty: fields.cvv.isEmpty
                                    }
                                });
                            });
                            BrainTreeHostedFieldsInstance === null || BrainTreeHostedFieldsInstance === void 0 ? void 0 : BrainTreeHostedFieldsInstance.on('blur', function (event) {
                                var _a;
                                var fields = event.fields;
                                (_a = callbacks.onCardFieldsStatusChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, {
                                    number: {
                                        focused: fields.number.isFocused,
                                        empty: fields.number.isEmpty
                                    },
                                    expirationDate: {
                                        focused: fields.expirationDate.isFocused,
                                        empty: fields.expirationDate.isEmpty
                                    },
                                    cvv: {
                                        focused: fields.cvv.isFocused,
                                        empty: fields.cvv.isEmpty
                                    }
                                });
                            });
                            formRef.current.addEventListener('submit', function (event) {
                                event.preventDefault();
                                BrainTreeHostedFieldsInstance === null || BrainTreeHostedFieldsInstance === void 0 ? void 0 : BrainTreeHostedFieldsInstance.tokenize({
                                    vault: true
                                }, function (tokenizeErr, payload) {
                                    var _a, _b;
                                    if (tokenizeErr) {
                                        (_a = callbacks.onSubmit) === null || _a === void 0 ? void 0 : _a.call(callbacks, {
                                            encryptedCustomerInput: tokenizeErr.code,
                                            paymentType: SupportedPaymentMethods.WEB_DROP_IN_CREDIT_CARD
                                        });
                                        return;
                                    }
                                    if (!payload) {
                                        console.error('Did not receive tokenizeErr or payload from braintree! Need to investigate.');
                                        return;
                                    }
                                    var encryptedData = { nonce: payload.nonce, bin: payload.details.bin };
                                    (_b = callbacks.onSubmit) === null || _b === void 0 ? void 0 : _b.call(callbacks, {
                                        encryptedCustomerInput: encryptedData,
                                        paymentType: SupportedPaymentMethods.WEB_DROP_IN_CREDIT_CARD
                                    });
                                });
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    BraintreeAdapter.prototype.submitPaymentForm = function (config, paymentInformation, threedsActionContainer, setErrorDetails, actionCallback, onPaymentSuccess, onPaymentFailure) {
        return __awaiter(this, void 0, void 0, function () {
            var paymentMethod, baseResponse, decodedPaymentInfo, encodedPaymentInfo, client, tokenizationResult, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setErrorDetails(undefined);
                        paymentMethod = config.getSelectedPaymentMethod();
                        if (!paymentMethod) {
                            throw new Error('No payment method selected');
                        }
                        baseResponse = {
                            paymentMethod: SupportedPaymentMethodMappings[paymentInformation.paymentType]
                        };
                        decodedPaymentInfo = paymentInformation.encryptedCustomerInput;
                        encodedPaymentInfo = __assign(__assign({}, paymentInformation), { encryptedCustomerInput: btoa(JSON.stringify(decodedPaymentInfo)) });
                        if (!(config.enable3DSecure && paymentInformation.paymentType === SupportedPaymentMethods.WEB_DROP_IN_CREDIT_CARD)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.braintreeClient];
                    case 1:
                        client = _a.sent();
                        threeDSecure.create({
                            version: 2,
                            client: client
                        }, function (err, threeDSInstance) { return __awaiter(_this, void 0, void 0, function () {
                            var billingAddress;
                            var _this = this;
                            var _a, _b, _c, _d;
                            return __generator(this, function (_e) {
                                if (err) {
                                    setErrorDetails({
                                        name: err.name,
                                        type: ErrorType.NonRetriable,
                                        message: err.code
                                    });
                                    onPaymentFailure === null || onPaymentFailure === void 0 ? void 0 : onPaymentFailure(PaymentError.parsePaymentFailure(baseResponse, err));
                                    this.onProcessing(false);
                                    return [2 /*return*/];
                                }
                                billingAddress = {
                                    streetAddress: (_b = (_a = paymentInformation.billingInformation) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.address1,
                                    postalCode: (_d = (_c = paymentInformation.billingInformation) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.postalCode
                                };
                                threeDSInstance === null || threeDSInstance === void 0 ? void 0 : threeDSInstance.on('lookup-complete', function (data, next) {
                                    next === null || next === void 0 ? void 0 : next();
                                });
                                threeDSInstance === null || threeDSInstance === void 0 ? void 0 : threeDSInstance.verifyCard({
                                    nonce: decodedPaymentInfo.nonce,
                                    bin: decodedPaymentInfo.bin,
                                    collectDeviceData: true,
                                    billingAddress: billingAddress,
                                    amount: convertToDollars(config.amount.amount)
                                }, function (err, data) { return __awaiter(_this, void 0, void 0, function () {
                                    var tokenizationResult, error_2;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (err) {
                                                    setErrorDetails({
                                                        name: err.name,
                                                        type: ErrorType.NonRetriable,
                                                        message: err.code
                                                    });
                                                    onPaymentFailure === null || onPaymentFailure === void 0 ? void 0 : onPaymentFailure(PaymentError.parsePaymentFailure(baseResponse, err));
                                                    this.onProcessing(false);
                                                    return [2 /*return*/];
                                                }
                                                if (!(data === null || data === void 0 ? void 0 : data.threeDSecureInfo.liabilityShifted)) return [3 /*break*/, 5];
                                                encodedPaymentInfo = __assign(__assign({}, paymentInformation), { encryptedCustomerInput: btoa(JSON.stringify({ nonce: data === null || data === void 0 ? void 0 : data.nonce })) });
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([1, 3, , 4]);
                                                return [4 /*yield*/, this.billingGatewayService.submitTokenizationIntent(config, encodedPaymentInfo)];
                                            case 2:
                                                tokenizationResult = _a.sent();
                                                if (tokenizationResult.resultCode === 'Success') {
                                                    onPaymentSuccess === null || onPaymentSuccess === void 0 ? void 0 : onPaymentSuccess(__assign(__assign({}, baseResponse), { ok: true, status: 'success', billingToken: config.billingToken, billingInformation: config.billingInformation, additionalData: this.parseAdditionalTransactionInfo(paymentMethod, tokenizationResult) }));
                                                    this.onProcessing(false);
                                                    return [2 /*return*/];
                                                }
                                                return [3 /*break*/, 4];
                                            case 3:
                                                error_2 = _a.sent();
                                                setErrorDetails(error_2);
                                                onPaymentFailure === null || onPaymentFailure === void 0 ? void 0 : onPaymentFailure(PaymentError.parsePaymentFailure(baseResponse, error_2));
                                                this.onProcessing(false);
                                                return [2 /*return*/];
                                            case 4: return [3 /*break*/, 6];
                                            case 5:
                                                setErrorDetails({
                                                    message: 'Unable to verify 3DSecure status for card',
                                                    type: ErrorType.NonRetriable,
                                                    name: '3DSecure Error'
                                                });
                                                onPaymentFailure === null || onPaymentFailure === void 0 ? void 0 : onPaymentFailure(__assign(__assign({}, baseResponse), { ok: false, status: 'error', reason: 'Unable to verify 3DSecure status for card' }));
                                                this.onProcessing(false);
                                                return [2 /*return*/];
                                            case 6: return [2 /*return*/];
                                        }
                                    });
                                }); });
                                return [2 /*return*/];
                            });
                        }); });
                        return [3 /*break*/, 5];
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.billingGatewayService.submitTokenizationIntent(config, encodedPaymentInfo)];
                    case 3:
                        tokenizationResult = _a.sent();
                        if (tokenizationResult.resultCode === 'Success') {
                            onPaymentSuccess === null || onPaymentSuccess === void 0 ? void 0 : onPaymentSuccess(__assign(__assign({}, baseResponse), { ok: true, status: 'success', billingToken: config.billingToken, billingInformation: config.billingInformation, additionalData: this.parseAdditionalTransactionInfo(paymentMethod, tokenizationResult) }));
                            this.onProcessing(false);
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        setErrorDetails(error_1);
                        onPaymentFailure === null || onPaymentFailure === void 0 ? void 0 : onPaymentFailure(PaymentError.parsePaymentFailure(baseResponse, error_1));
                        this.onProcessing(false);
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BraintreeAdapter.prototype.initializePayPal = function (formRef, paypalConfiguration, callback, onShopperDetails, // unused for braintree but is required as parameter
    isPayPalAvailable, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var traditionalLocale, client;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.renderedComponents.paypal) {
                            return [2 /*return*/];
                        }
                        this.renderedComponents.paypal = true;
                        traditionalLocale = getTraditionalLocale(locale);
                        return [4 /*yield*/, this.braintreeClient];
                    case 1:
                        client = _a.sent();
                        paypalCreate({
                            client: client
                        }, function (err, checkout) { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return __generator(this, function (_a) {
                                if (err) {
                                    throw new PaymentError(ErrorType.NonRetriable, err.message);
                                }
                                checkout === null || checkout === void 0 ? void 0 : checkout.loadPayPalSDK({
                                    'disable-funding': 'card,credit',
                                    vault: true,
                                    locale: traditionalLocale // works on the Paypal loading background screen
                                }, function (err, checkout) {
                                    if (err || window.paypal === undefined) {
                                        throw new PaymentError(ErrorType.NonRetriable, (err === null || err === void 0 ? void 0 : err.message) || 'window.paypal is not set');
                                    }
                                    // eslint-disable-next-line
                                    window.paypal
                                        .Buttons({
                                        style: {
                                            // eslint-disable-next-line
                                            // @ts-ignore
                                            disableMaxWidth: true,
                                            height: 48 // as defined in figma
                                        },
                                        // eslint-disable-next-line
                                        // @ts-ignore
                                        createBillingAgreement: function () {
                                            return checkout === null || checkout === void 0 ? void 0 : checkout.createPayment({
                                                // @ts-expect-error type doesn't exist
                                                flow: 'vault'
                                                // locale: traditionalLocale // does not work on the Sandbox payment screen
                                            });
                                        },
                                        onInit: function () { return isPayPalAvailable(true); },
                                        onCancel: function () {
                                            _this.onProcessing(false);
                                        },
                                        onClick: function () {
                                            _this.onProcessing(true);
                                        },
                                        onError: function () {
                                            _this.onProcessing(false);
                                        },
                                        // eslint-disable-next-line
                                        // @ts-ignore
                                        onApprove: function (data) { return __awaiter(_this, void 0, void 0, function () {
                                            var paypalResponse, reencoded;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, (checkout === null || checkout === void 0 ? void 0 : checkout.tokenizePayment(data))];
                                                    case 1:
                                                        paypalResponse = _a.sent();
                                                        if (!paypalResponse) {
                                                            console.error('Braintree PayPal tokenize failure');
                                                        }
                                                        reencoded = {
                                                            data: {
                                                                paymentMethod: { nonce: paypalResponse === null || paypalResponse === void 0 ? void 0 : paypalResponse.nonce }
                                                            }
                                                        };
                                                        callback(reencoded, null);
                                                        return [2 /*return*/, paypalResponse];
                                                }
                                            });
                                        }); }
                                    })
                                        .render('#paypal-container');
                                });
                                return [2 /*return*/];
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    // This should be remove shortly, the correct implementation should be done in the BG Core.
    BraintreeAdapter.prototype.parseAdditionalTransactionInfo = function (paymentMethod, tokenizationResponse) {
        var _a, _b, _c, _d, _e;
        switch (paymentMethod) {
            case SupportedPaymentMethodMappings.webDropInCreditCard: {
                var cardBrand = (_a = tokenizationResponse === null || tokenizationResponse === void 0 ? void 0 : tokenizationResponse.additionalData) === null || _a === void 0 ? void 0 : _a.brand;
                var cardLastFourDigits = (_b = tokenizationResponse === null || tokenizationResponse === void 0 ? void 0 : tokenizationResponse.additionalData) === null || _b === void 0 ? void 0 : _b.cardSummary;
                var cardBin = (_c = tokenizationResponse === null || tokenizationResponse === void 0 ? void 0 : tokenizationResponse.additionalData) === null || _c === void 0 ? void 0 : _c.cardBin;
                var cardExpirationDate = (_d = tokenizationResponse === null || tokenizationResponse === void 0 ? void 0 : tokenizationResponse.additionalData) === null || _d === void 0 ? void 0 : _d.expiryDate;
                if (cardExpirationDate) {
                    var parsedDate = dayjs(cardExpirationDate, ['M/YYYY', 'MM/YYYY'], true);
                    cardExpirationDate = undefined;
                    if (parsedDate.isValid()) {
                        cardExpirationDate = parsedDate.format('MM/YYYY').toString();
                    }
                }
                return { cardBin: cardBin, cardBrand: cardBrand, cardExpirationDate: cardExpirationDate, cardLastFourDigits: cardLastFourDigits };
            }
            case SupportedPaymentMethodMappings.webDropInPaypal: {
                var paypalEmail = (_e = tokenizationResponse === null || tokenizationResponse === void 0 ? void 0 : tokenizationResponse.additionalData) === null || _e === void 0 ? void 0 : _e.paypalEmail;
                return { paypalEmail: paypalEmail };
            }
            default:
                return {};
        }
    };
    return BraintreeAdapter;
}(VendorPaymentAdapter));
export { BraintreeAdapter };
